/**
 * Partner queue columns: expand · client/script · type · scripts · status · received · due · action.
 * Status/due enter at `sm`, type and scripts at `md`, received at `lg`.
 */
export const PARTNER_QUEUE_GRID_CLASS =
  "grid items-center gap-x-3 " +
  "grid-cols-[1rem_minmax(0,1fr)_5.5rem] " +
  "sm:grid-cols-[1rem_minmax(0,1fr)_11rem_10rem_5.5rem] " +
  "md:grid-cols-[1rem_minmax(0,1fr)_4.5rem_3.5rem_11rem_10rem_5.5rem] " +
  "lg:grid-cols-[1rem_minmax(0,1fr)_4.5rem_3.5rem_11rem_8.5rem_10rem_5.5rem]";

export const PARTNER_QUEUE_CELL_TYPE_CLASS = "hidden md:block";
export const PARTNER_QUEUE_CELL_SCRIPTS_CLASS = "hidden md:block";
export const PARTNER_QUEUE_CELL_STATUS_CLASS = "hidden sm:block";
export const PARTNER_QUEUE_CELL_RECEIVED_CLASS = "hidden lg:block";
export const PARTNER_QUEUE_CELL_DUE_CLASS = "hidden sm:block";
export const PARTNER_QUEUE_ROW_PADDING_CLASS = "px-3";
